import { Textarea } from '@components/core-ui/form-elements/Textarea';
import styled from 'styled-components';

export const StyledTextarea = styled(Textarea).attrs({
  className: 'textarea-wrapper w-full',
})`
  width: 100%;

  textarea {
    width: 100%;

    &::placeholder {
      color: var(--color-form-field-placeholder, var(--color-text-muted));
    }
  }
`;
